module.exports = __webpack_public_path__ + "static/flemings-steakhouse.5464468e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flemings-steakhouse.jpg
// module id = 630
// module chunks = 262104617495404